/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_No_Orgs_AffiliateInputs */



/**
* | output |
* | --- |
* | "Affiliate partners have no managed organizations — their customers are attributed by referral code and appear under commissions." |
*
* @param {Partner_Admin_No_Orgs_AffiliateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_no_orgs_affiliate = /** @type {((inputs?: Partner_Admin_No_Orgs_AffiliateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_No_Orgs_AffiliateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Affiliate-Partner verwalten keine Organisationen — ihre Kunden werden über Empfehlungscodes zugeordnet und erscheinen unter Provisionen.")
	return /** @type {LocalizedString} */ ("Affiliate partners have no managed organizations — their customers are attributed by referral code and appear under commissions.")
});